import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Side-effect CSS: @matchday/ui's index imports tokens + system-pattern styles;
// juice.css carries the primitive keyframes. App-level styles come last so they
// can layer on the tokens without ever redefining them.
import "@matchday/juice/juice.css";
import App from "./App";
import "./styles/player.css";
// Above-the-fold faces preloaded at module-eval time — before first render and
// before CSS @font-face discovery (FLAT-001; KICKOFF §3.2). Only the two faces
// the S1 shell paints with; the other Poppins weights swap in on demand.
import antonWoff2 from "@matchday/ui/fonts/anton-400-latin.woff2?url";
import poppinsWoff2 from "@matchday/ui/fonts/poppins-400-latin.woff2?url";

for (const href of [antonWoff2, poppinsWoff2]) {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/woff2";
  link.crossOrigin = "anonymous";
  link.href = href;
  document.head.appendChild(link);
}

const root = document.getElementById("root");
if (root === null) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
